const noop = () => {
  // pass
}

const slardar =
  typeof window === 'undefined' ? noop : (window as any).Slardar || noop

type Value = string | number | boolean | Record<string, any>
type Tag = Record<string, string | number | boolean | undefined | null>

function _log(value: Value, level = 'info', tags?: Tag) {
  const consoleMethod =
    level === 'info' ? 'log' : level === 'warn' ? 'warn' : 'error'
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    console[consoleMethod](value, tags)
    return
  }
  const logMessage = typeof value === 'object' ? JSON.stringify(value) : value
  if (typeof window !== 'undefined') {
    slardar('emit', 'log', {
      value: logMessage,
      level,
      tags,
    })
    return
  }
  switch (level) {
    case 'error':
      console.error(logMessage)
      break
    case 'warn':
      console.warn(logMessage)
      break
    default:
      console.log(logMessage)
  }
}
const logger = {
  error: (value: Value, tags?: Tag) => {
    _log(value, 'error', tags)
  },
  warn: (value: Value, tags?: Tag) => {
    _log(value, 'warn', tags)
  },
  log: (value: Value, tags?: Tag) => {
    _log(value, 'info', tags)
  },
  info: (value: Value, tags?: Tag) => {
    _log(value, 'info', tags)
  },
}

function _send(name = '', tags = {}) {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    console.log(name, tags)
    return
  }

  slardar('emit', 'counter', {
    name,
    value: 1,
    tags,
  })
}

function _sendTimer(name = '', value: number, tags = {}) {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test'
  ) {
    console.log(name, value, tags)
    return
  }

  slardar('emit', 'timer', {
    name,
    value,
    tags,
  })
}

const metrics = {
  counter: (name: string, tags?: Tag) => {
    _send(name, tags)
  },
  timer: (name: string, value: number, tags?: Tag) => {
    _sendTimer(name, value, tags)
  },
}

export { logger, metrics }
